import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';
import { useU2000AuthContext } from '../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000FormStateHandlers } from '../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import { U2000FormStateEnumState } from '../../../u2000Core/reducer/formReducer/U2000FormState';
import { NS, U3202ROLES } from '../../U3202';
import type { U3202OrgProviderConfigFormData } from '../../U3202Service';

interface U3202OrgProviderConfigFormToolBarProps {
  formStateHandlers: U2000FormStateHandlers<U3202OrgProviderConfigFormData> & {
    getFormState: () => U2000FormStateEnumState;
    addNewConfig: () => void;
    modifyConfig: () => void;
    deleteConfig: () => void;
  };
}

export const U3202OrgProviderConfigFormToolBar: React.FC<U3202OrgProviderConfigFormToolBarProps> = ({
  formStateHandlers,
}) => {
  const formState = formStateHandlers.getFormState();
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: 'add',
      label: t('configList.addProvider', { ns: NS }),
      hasRole: hasRole(U3202ROLES.EDIT),
      handleClick: () => formStateHandlers.addNewConfig(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3202ROLES.EDIT),
      handleClick: () => formStateHandlers.modifyConfig(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3202ROLES.DELETE),
      handleClick: () => formStateHandlers.deleteConfig(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
